<template>
  <div class="neo-section black">
    <div class="neo-container">
      <h2 data-aos="fade-up">How it Works</h2>
      <div class="neo-how">
        <img
          class="neo-how__bg"
          :src="getWebsiteImage('neo-ellipse.png')"
          alt="O"
        />
        <el-row type="flex">
          <el-col :md="24" :lg="12">
            <div class="neo-how__content" data-aos="fade-up">
              <neo-step
                :number="1"
                title="Sign Up"
                text="Just be 18 or older with a valid SSN/Passport ID. Based on your credit history, you might need to make a security deposit from your bank"
              />
              <neo-step
                :number="2"
                title="Add Family"
                text="Choose loved ones in Nigeria to receive money directly from you. They just need a valid Government ID (BVN, NIN)."
              />
              <neo-step
                :number="3"
                title="Unlock the NEO Card Benefit! "
                subtitle="coming soon"
                text="Send money with NEO, and qualify for NEO Cards for your family in Nigeria 🇳🇬. With NEO, you're in charge. Choose how much money to give each person. Stop it whenever you want. Check all the spending. Pay the bill once a month, and you can even set it to pay automatically. It's easy!"
              />
            </div>
          </el-col>
          <el-col :md="24" :lg="12">
            <div class="neo-how__content image" data-aos="flip-right">
              <div class="neo-how__content-image">
                <div class="card">
                  <img
                    :src="getWebsiteImage('neo-card-mastercard.png')"
                    alt="O"
                  />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import NeoStep from "@/components/Website/NeoStep";

export default {
  name: "NeoHowItWorks",
  components: { NeoStep },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: #ffffff;
}

.neo-how {
  margin-top: 80px;
  min-height: 500px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__bg {
    height: 100%;
    width: auto;
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
  }

  &__content {
    &-image {
      .card {
        transform: rotate(-25.5deg);
      }
    }
  }
}

@media (max-width: 1200px) {
  .neo-how {
    min-height: 300px;
    flex-direction: column;
    justify-content: space-around;

    &__bg {
      display: none;
    }

    &__content {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      .neo-step {
        width: 45%;

        &:last-child {
          width: 80%;
        }
      }

      &.image {
        display: none;
      }
    }
  }
}

@media (max-width: 600px) {
  .neo-how {
    min-height: 300px;

    &__content {
      flex-direction: column;
      margin-bottom: 40px;

        .neo-step {
            width: 100% !important;
        }
    }
  }
}
</style>
